import { normalize } from 'normalizr'

import mixpanel, { EVENTS } from 'services/mix-panel'
import schema from './schema'

export const FETCHED_ONE = 'ALARM/FETCHED_ONE'
export const TURNED_OFF = 'ALARM/TURNED_OFF'
export const FETCHED_ALL = 'ALARM/FETCHED_ALL'
export const DELETED = 'ALARM/DELETED'

export function fetchOne(id) {
  return async (dispatch, getState, api) => {
    const response = await api.alarm.fetchOne(id)    
    dispatch({
      type: FETCHED_ONE,
      payload: normalize(response, schema),
    })
    return response
  }
}

export function fetchAll() {
  return async (dispatch, getState, api) => {
    const response = await api.alarm.fetchAll()
    dispatch({
      type: FETCHED_ALL,
      payload: normalize(response, [schema]),
    })
    return response
  }
}

export function create(data) {
  return async (dispatch, getState, api) => {    
    const response = await api.alarm.create({ ...data, mode: 'manual' })

    mixpanel.track(EVENTS.ALARM_SET)
    // dispatch({
    //   type: FETCHED_ONE,
    //   payload: normalize(response, schema),
    // })
    return response
  }
}

export function triggerSOS() {
  return async (dispatch, getState, api) => {
    const response = await api.alarm.triggerSOS({ mode: 'manual' })

    mixpanel.track(EVENTS.ALARM_SET)
    dispatch({
      type: FETCHED_ONE,
      payload: normalize(response, schema),
    })
    return response
  }
}

export function update(id, data) {
  return async (dispatch, getState, api) => {
    const response = await api.alarm.update(id, data)
    dispatch({
      type: FETCHED_ONE,
      payload: normalize(response, schema),
    })
    return response
  }
}

export function turnOff(id) {
  return async (dispatch, getState, api) => {
    const response = await api.alarm.turnOff(id)
    dispatch({
      type: TURNED_OFF,
    })
    return response
  }
}

export function deleteAlarm(id) {
  return async (dispatch, getState, api) => {
    const response = await api.alarm.delete(id)
    return response
  }
}
